<template>
    <div class="card">
        <img
            :src="story.image ? story.image : 'img/encounter.jpg'"
            class="card-img-top square-img rounded-bottom-0"
            alt="{{ story.name }}"
        />
        <div
            class="card-img-overlay card-img-overlay-limited rounded-bottom-0 text-light"
        >
            <p class="card-text fw-bold text-end">
                <span class="card-title">{{ story.name }}</span>
            </p>
        </div>
        <div class="card-footer d-flex">
            <router-link
                :to="{ name: 'Story', params: { id: story.id } }"
                class="btn btn-primary no-round btm-left-round flex-grow-1"
                ><font-awesome-icon icon="eye"
            /></router-link>
            <button
                @click="deleteStory(story.id)"
                class="btn btn-danger no-round flex-grow-1"
            >
                <font-awesome-icon icon="trash-alt" />
            </button>
            <button
                @click="exportStory(story)"
                class="btn btn-success no-round btm-right-round flex-grow-1"
            >
                <font-awesome-icon icon="save" />
            </button>
        </div>
    </div>
</template>

<script>
import { useRosterStore } from "@/stores/index";

export default {
    name: 'StoryBox',
    data() {
        return {
            store: useRosterStore(),
        };
    },
    props: {
        // Define any props if needed
        story: {
            type: Object,
            required: true,
        },
    },
    methods:{
        deleteStory(id) {
            if (
                window.confirm(
                    "Are you sure you want to delete this story?"
                )
            ) {
                this.store.removeStory(id);
            }
        },
        exportStory(story) {
            const { id, ...rest } = story; // drop the id
            const dataStr = JSON.stringify(rest, null, 2);
            const blob = new Blob([dataStr], {
                type: "application/octet-stream",
            }); // ✅ generic MIME type
            const url = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = story.name + ".story"; // ✅ will now be preserved
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            URL.revokeObjectURL(url);
        },
    }
};
</script>

<style scoped>
.card {
    border-color: #000 !important;
}
.card-footer {
    border-top: none !important;
}
.square-img {
    width: 100%; /* Make the width 100% of the container */
    aspect-ratio: 1 / 1; /* Maintain a 1:1 aspect ratio */
    object-fit: cover; /* Ensure the image covers the area without distortion */
    object-position: top; /* Position the image at the top */
}
.card-img-overlay-limited {
    width: 100%; /* Make the width 100% of the container */
    aspect-ratio: 1 / 1; /* Maintain a 1:1 aspect ratio */
    top: 0; /* Adjust 50px to the height of your buttons */
    display: flex;
    align-items: flex-end;
    justify-content: right;
    padding-bottom: 10px; /* Adjust as needed */
    background: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.7) 0%,
        rgba(0, 0, 0, 0) 50%
    );
}
.card-footer {
    padding: 0 !important;
}
.no-round {
    border-radius: 0 !important; /* Override any existing border-radius */
}

.btm-left-round {
    border-bottom-left-radius: 5px !important; /* Override any existing border-radius */
}

.btm-right-round {
    border-bottom-right-radius: 5px !important; /* Override any existing border-radius */
}
</style>
